import { useState, useEffect } from "react";
import Modal from "./Modal";
import CreateCampaignForm from "./CreateCampaignForm";
import axiosInstance from "../../redux/helpers/axios";

const ACCENT_FROM = "#E11D74";
const ACCENT_TO = "#EF4444";

export default function CampaignsPage() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const fetchCampaigns = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/admin/campaign/get-all");
      setCampaigns(res.data.campaigns || []);
      setError(null);
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to load campaigns");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const handleCreated = (campaign) => {
    setCampaigns((prev) => [campaign, ...prev]);
    setModalOpen(false);
  };

  return (
    <div className="max-w-5xl mx-auto p-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">Campaigns</h1>
          <p className="mt-1 text-sm text-gray-500">
            All campaigns across Ali Store BD.
          </p>
        </div>
        <button
          onClick={() => setModalOpen(true)}
          className="rounded-md px-4 py-2 text-sm font-medium text-white"
          style={{
            background: `linear-gradient(90deg, ${ACCENT_FROM}, ${ACCENT_TO})`,
          }}
        >
          + New campaign
        </button>
      </div>

      <div className="mt-6 overflow-hidden rounded-lg border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Name
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Slug
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Start
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                End
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 bg-white">
            {loading && (
              <tr>
                <td
                  colSpan={4}
                  className="px-4 py-6 text-center text-sm text-gray-400"
                >
                  Loading...
                </td>
              </tr>
            )}
            {!loading && error && (
              <tr>
                <td
                  colSpan={4}
                  className="px-4 py-6 text-center text-sm text-red-600"
                >
                  {error}
                </td>
              </tr>
            )}
            {!loading && !error && campaigns.length === 0 && (
              <tr>
                <td
                  colSpan={4}
                  className="px-4 py-6 text-center text-sm text-gray-400"
                >
                  No campaigns yet.
                </td>
              </tr>
            )}
            {!loading &&
              !error &&
              campaigns.map((c) => (
                <tr key={c.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm font-medium text-gray-900">
                    {c.name}
                  </td>
                  <td className="px-4 py-3 text-sm font-mono text-gray-500">
                    {c.slug}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500">
                    {c.startDate
                      ? new Date(c.startDate).toLocaleDateString()
                      : "—"}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500">
                    {c.endDate ? new Date(c.endDate).toLocaleDateString() : "—"}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title="New campaign"
      >
        <CreateCampaignForm
          onCreated={handleCreated}
          onCancel={() => setModalOpen(false)}
        />
      </Modal>
    </div>
  );
}
